<div [formGroup]="parts">
    <input  formControlName="textDate" (change)="changeDate()" >
</div>
 <!-- [textMask]="{mask: datemask}" -->

<!-- placeHolder="{{placeHolder}}" -->
